import { useCallback, useEffect, useState } from "react";

// Client-side watchlist persisted in localStorage. A custom event keeps every
// mounted component (pin buttons + the watchlist panel) in sync instantly.
const KEY = "ga_asset_watchlist";
const EVT = "ga-watchlist-change";
export const MAX_WATCH = 12;

const read = () => {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) || "[]");
    return Array.isArray(v) ? v : [];
  } catch {
    return [];
  }
};
const write = (list) => {
  localStorage.setItem(KEY, JSON.stringify(list));
  window.dispatchEvent(new Event(EVT));
};

export function useWatchlist() {
  const [list, setList] = useState(read);

  useEffect(() => {
    const sync = () => setList(read());
    window.addEventListener(EVT, sync);
    window.addEventListener("storage", sync);
    return () => {
      window.removeEventListener(EVT, sync);
      window.removeEventListener("storage", sync);
    };
  }, []);

  const toggle = useCallback((item) => {
    if (!item?.asset) return;
    const cur = read();
    const exists = cur.some((x) => x.asset === item.asset);
    const next = exists
      ? cur.filter((x) => x.asset !== item.asset)
      : [
          ...cur,
          { asset: item.asset, asset_name: item.asset_name || "", fingerprint: item.fingerprint || "", policy_id: item.policy_id || "" },
        ].slice(-MAX_WATCH);
    write(next);
  }, []);

  const remove = useCallback((asset) => write(read().filter((x) => x.asset !== asset)), []);
  const clear = useCallback(() => write([]), []);

  return { list, toggle, remove, clear };
}
